module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-246.8f61e1e1.svg";